enum DataEvent {
	DataExported = 'Data exported',
	DataDownloaded = 'Data downloaded',
}

export default DataEvent;
